// Client wrappers for the kiosk Cloud Functions (PRD_KioskTimeClock). Kiosk docs
// and PIN docs are deny-all to clients (firestore.rules C13), so the admin UI
// reaches them only through these callables.
import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions(undefined, "asia-southeast1");

export const listKiosksFn = httpsCallable(functions, "listKiosks");
export const createKioskFn = httpsCallable(functions, "createKiosk");
export const renameKioskFn = httpsCallable(functions, "renameKiosk");
export const repairKioskFn = httpsCallable(functions, "repairKiosk");
export const revokeKioskFn = httpsCallable(functions, "revokeKiosk");
export const setEmployeePinFn = httpsCallable(functions, "setEmployeePin");
